import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["data", "output"]
  }

  connect() {
    // The data target holds a literal, developer-authored JSON blob (its
    // prompt_content fields contain raw HTML) rather than an escaped value,
    // so it's read back via innerHTML rather than textContent - matching how
    // the original HelpPromptSetup read it with jQuery's .html().
    this.prompts = JSON.parse(this.dataTarget.innerHTML)
    this.openTag = null
    this.render()
  }

  toggle(event) {
    const tag = event.params.tag
    this.openTag = this.openTag === tag ? null : tag
    this.render()
  }

  close() {
    this.openTag = null
    this.render()
  }

  render() {
    this.outputTarget.innerHTML = this.prompts.map((prompt) => this.renderPrompt(prompt)).join("")
  }

  renderPrompt(prompt) {
    const overlay = this.openTag === prompt.help_prompt_tag ? this.renderOverlay(prompt) : ""

    return `
      <div class="help-prompt__link-container">
        <a class="help-prompt__link" data-action="click->help-prompt#toggle"
           data-help-prompt-tag-param="${this.escapeHtml(prompt.help_prompt_tag)}">
          ${this.escapeHtml(prompt.link_text)}
        </a>
        ${overlay}
      </div>
    `
  }

  renderOverlay(prompt) {
    const positionClass =
      prompt.prompt_position === "above"
        ? "help-prompt__overlay help-prompt__overlay--above"
        : "help-prompt__overlay help-prompt__overlay--below"
    const title = prompt.prompt_title
      ? `<div class="help-prompt__prompt_title">${this.escapeHtml(prompt.prompt_title)}</div>`
      : ""
    const links =
      (prompt.prompt_links || []).length > 0
        ? `<div>${prompt.prompt_links.map((link) => this.renderSupportLink(link)).join("")}</div>`
        : ""

    return `
      <div class="${positionClass}">
        <div class="help-prompt__overlay-close" data-action="click->help-prompt#close"></div>
        ${title}
        <div class="help-prompt__prompt_content">${prompt.prompt_content}</div>
        ${links}
      </div>
    `
  }

  renderSupportLink(link) {
    const icon = link.new_tab ? `<div class="help-prompt__support-link-icon"></div>` : ""
    const target = link.new_tab ? `target="_blank"` : ""

    return `
      <a href="${this.escapeHtml(link.link_url)}" ${target} class="help-prompt__support-link">
        <span class="help-prompt__support-link-text">${this.escapeHtml(link.link_text)}</span>
        ${icon}
      </a>
    `
  }

  escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;")
  }
}
